export const drawLoadingPlaceholder = (
    ctx: CanvasRenderingContext2D,
    width: number,
    height: number
) => {

    ctx.save();

    ctx.translate(0.5 * width, 0.5 * height);

    ctx.beginPath();
    ctx.moveTo(-20, 15);
    ctx.lineTo(-5, -10);
    ctx.lineTo(5, 5);
    ctx.lineTo(11, -3);
    ctx.lineTo(20, 15);
    ctx.closePath();
    ctx.fill();

    ctx.beginPath();
    ctx.arc(18, -6, 5, 0, Math.PI * 2, true);
    ctx.closePath();
    ctx.fill();

    ctx.restore();
};